export const API="https://stapi.maneemfi.com/";
// export const API="https://gomanee.com/";

// export const API="http://192.168.1.34:8080";